import SiteLayout from '@/layouts/site/SiteLayout.vue'

export default [
  {
    path: '/',
    component: SiteLayout,
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@/views/site/HomePage.vue'),
      },
      {
        path: 'app',
        name: 'app',
        meta: {
          title: 'App',
        },
        component: () => import('@/views/site/AppPage.vue'),
      },
      {
        path: 'golf-club',
        name: 'golf-club',
        meta: {
          title: 'Golf Club',
        },
        component: () => import('@/views/site/GolfClubPage.vue'),
      },
      {
        path: 'promo',
        name: 'club',
        meta: {
          title: 'Membership',
        },
        component: () => import('@/views/site/PromoPage.vue'),
      },
      {
        path: 'pace',
        name: 'pace',
        meta: {
          title: 'Pace of Play',
        },
        component: () => import('@/views/site/PacePage.vue'),
      },
      {
        path: 'about-us',
        name: 'about-us',
        meta: {
          title: 'About Us',
        },
        component: () => import('@/views/site/AboutPage.vue'),
      },
      {
        path: 'developers',
        name: 'developers',
        meta: {
          title: 'Developers',
        },
        component: () => import('@/views/site/DevelopersPage.vue'),
      },
      {
        path: 'privacy-policy',
        name: 'privacy-policy',
        meta: {
          title: 'Privacy Policy',
        },
        component: () => import('@/views/site/PrivacyPolicyPage.vue'),
      },
      {
        path: 'cookie-policy',
        name: 'cookie-policy',
        meta: {
          title: 'Cookie Policy',
        },
        component: () => import('@/views/site/CookiePolicyPage.vue'),
      },
      {
        path: 'api-license',
        name: 'api-license',
        meta: {
          title: 'API License Agreement',
        },
        component: () => import('@/views/site/ApiLicensePage.vue'),
      },
      {
        path: 'terms-and-conditions',
        name: 'terms-and-conditions',
        meta: {
          title: 'Terms and Conditions',
        },
        component: () => import('@/views/site/TermsPolicyPage.vue'),
      },
      {
        path: 'email-confirmed',
        name: 'email-confirmed',
        meta: {
          title: 'Email Confirmed',
        },
        component: () => import('@/views/site/EmailConfirmedPage.vue'),
      },
      {
        path: 'email-not-confirmed',
        name: 'email-not-confirmed',
        meta: {
          title: 'Email Not Confirmed',
        },
        component: () => import('@/views/site/EmailNotConfirmedPage.vue'),
      },
      {
        path: 'send-confirmed',
        name: 'send-confirmed',
        meta: {
          title: 'Send Confirmed',
        },
        component: () => import('@/views/site/SendConfirmedPage.vue'),
      },
      {
        path: 'blog',
        name: 'blog',
        meta: {
          title: 'Blog',
        },
        component: () => import('@/views/site/blog/BlogPage.vue'),
      },
      {
        path: 'blog/:post',
        name: 'blog-post',
        meta: {
          title: 'Blog post',
        },
        component: () => import('@/views/site/blog/PostPage.vue'),
      },
    ],
  },
]
